var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdSolar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F3FF0A",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M11.25 3v2.25h1.5V3h-1.5zM6.167 5.106l-1.06 1.061 1.59 1.59 1.06-1.06-1.59-1.59zm11.666 0l-1.59 1.591 1.06 1.06 1.59-1.59-1.06-1.06zM12 6.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5zm-9 4.5v1.5h2.25v-1.5H3zm15.75 0v1.5H21v-1.5h-2.25zM6.697 16.242l-1.59 1.591 1.06 1.06 1.59-1.59-1.06-1.06zm10.606 0l-1.06 1.06 1.59 1.592 1.06-1.061-1.59-1.59zM11.25 18.75V21h1.5v-2.25h-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdSolar);
export default __webpack_public_path__ + "static/media/icon-pd-solar.fe189f498c8fe39aaf761b2a5d6dab78.svg";
export { ForwardRef as ReactComponent };